import { Link } from "react-router-dom";
import Sidebar from "@/components/feature/Sidebar";
import FeedbackForm from "@/pages/about/components/FeedbackForm";
import { articles } from "@/mocks/articles";

export default function AboutPage() {
  const missions = [
    {
      icon: "ri-focus-3-line",
      title: "聚焦法律与伦理",
      desc: "围绕近亲性关系相关的法律法规、伦理框架与社会规范，提供系统、成体系的知识梳理。",
    },
    {
      icon: "ri-book-open-line",
      title: "严谨、可溯源",
      desc: "内容基于现行公开法律法规与公开研究资料整理，重要结论均标注来源，便于读者核对。",
    },
    {
      icon: "ri-heart-2-line",
      title: "尊重与克制",
      desc: "讨论严肃议题时保持克制，拒绝猎奇渲染，始终把受害者与弱势群体的处境放在首位。",
    },
  ];

  const reviewSteps = [
    { title: "选题立项", desc: "依据公众常见疑问与实务关注点确定选题，明确知识点与边界。" },
    { title: "资料整理", desc: "以公开法律法规、司法解释与公开研究为来源，标注出处与适用时间。" },
    { title: "内容撰写", desc: "由编辑团队撰写，注重准确、克制与可读性，避免细节渲染。" },
    { title: "交叉复核", desc: "对法律条文与结论进行交叉核对，示例与案例统一采用虚构或去标识化处理。" },
  ];

  return (
    <div className="mx-auto flex w-full max-w-[1280px] flex-col gap-8 px-4 py-8 md:px-8 lg:flex-row">
      <Sidebar />

      <div className="min-w-0 flex-1">
        <nav className="mb-4 flex items-center gap-1.5 text-xs text-foreground-500" aria-label="面包屑">
          <Link to="/" className="transition-colors hover:text-primary-700">
            首页
          </Link>
          <i className="ri-arrow-right-s-line" />
          <span className="text-foreground-800">关于</span>
        </nav>

        {/* 头部 */}
        <header className="mb-8 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="bg-primary-900 px-6 py-10 md:px-10 md:py-12">
            <span className="mb-4 inline-flex items-center gap-1.5 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1 text-xs text-background-100 backdrop-blur">
              <i className="ri-information-line" />
              关于本站
            </span>
            <h1 className="max-w-3xl text-2xl font-black leading-snug text-background-50 md:text-4xl">
              让严肃的议题，被理性而准确地讨论
            </h1>
            <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-100/85">
              乱伦专题是一个面向公众、法律从业人员与伦理学研究者的法律与伦理知识门户。
              我们希望用严谨、克制、可溯源的内容，帮助读者准确理解法律界限与社会规范，提升法律意识与道德认知。
            </p>
          </div>
        </header>

        {/* 使命 */}
        <section className="mb-10">
          <h2 className="mb-5 flex items-center gap-2 text-xl font-bold text-foreground-950">
            <i className="ri-flag-2-line text-accent-600" />
            我们的使命
          </h2>
          <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
            {missions.map((item) => (
              <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="mb-4 flex h-11 w-11 items-center justify-center rounded-lg bg-primary-50 text-primary-700">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <h3 className="mb-2 text-base font-bold text-foreground-950">{item.title}</h3>
                <p className="text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* 数据 */}
        <section className="mb-10 grid grid-cols-2 gap-4 md:grid-cols-4">
          {[
            { value: `${articles.length}+`, label: "科普内容", icon: "ri-article-line" },
            { value: "3", label: "主题分类", icon: "ri-layout-grid-line" },
            { value: "100%", label: "虚构/公开来源", icon: "ri-shield-check-line" },
            { value: "0", label: "需登录/付费", icon: "ri-lock-unlock-line" },
          ].map((item) => (
            <div key={item.label} className="rounded-lg border border-background-200 bg-background-100 p-5 text-center">
              <i className={`${item.icon} text-xl text-primary-600`} />
              <p className="mt-3 font-heading text-2xl font-bold text-foreground-950">{item.value}</p>
              <p className="text-xs text-foreground-500">{item.label}</p>
            </div>
          ))}
        </section>

        {/* 内容来源与审核机制 */}
        <section className="mb-10">
          <h2 className="mb-5 flex items-center gap-2 text-xl font-bold text-foreground-950">
            <i className="ri-git-commit-line text-secondary-600" />
            内容来源与审核机制
          </h2>
          <ol className="relative flex flex-col gap-5 border-l border-background-300 pl-6">
            {reviewSteps.map((step, index) => (
              <li key={step.title} className="relative">
                <span className="absolute -left-[31px] flex h-6 w-6 items-center justify-center rounded-full bg-secondary-500 text-xs font-bold text-background-50">
                  {index + 1}
                </span>
                <h3 className="text-base font-bold text-foreground-950">{step.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
              </li>
            ))}
          </ol>
        </section>

        {/* 联系方式 */}
        <section className="mb-10">
          <h2 className="mb-5 flex items-center gap-2 text-xl font-bold text-foreground-950">
            <i className="ri-customer-service-2-line text-primary-600" />
            联系方式
          </h2>
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-3">
            <a
              href="mailto:contact@incest-law-ethics.example"
              className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:bg-background-100"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-50 text-primary-700">
                <i className="ri-mail-line text-lg" />
              </span>
              <div>
                <p className="text-sm font-semibold text-foreground-950">邮件联系</p>
                <p className="text-xs text-foreground-500">contact@incest-law-ethics.example</p>
              </div>
            </a>
            <div className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-50 text-secondary-700">
                <i className="ri-time-line text-lg" />
              </span>
              <div>
                <p className="text-sm font-semibold text-foreground-950">回复时效</p>
                <p className="text-xs text-foreground-500">一般 3 个工作日内答复</p>
              </div>
            </div>
            <div className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-50 text-accent-700">
                <i className="ri-alert-line text-lg" />
              </span>
              <div>
                <p className="text-sm font-semibold text-foreground-950">紧急求助</p>
                <p className="text-xs text-foreground-500">如遇现实危险，请立即报警或联系专业机构</p>
              </div>
            </div>
          </div>
        </section>

        {/* 反馈表单 */}
        <section id="feedback" className="mb-4">
          <h2 className="mb-2 flex items-center gap-2 text-xl font-bold text-foreground-950">
            <i className="ri-chat-forward-line text-primary-600" />
            反馈与咨询
          </h2>
          <p className="mb-5 text-sm text-foreground-600">
            发现内容有误、希望补充某个主题，或对我们的工作有建议，欢迎通过下方表单告诉我们。
          </p>
          <FeedbackForm />
        </section>
      </div>
    </div>
  );
}